import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export interface FaqItem {
  id: number;
  uid: string;
  title: string;
  content: string;
  createdAt: string;
  updatedAt: string;
}

export const FaqApi = createApi({
  reducerPath: "faqApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["FAQ"],
  endpoints: (build) => ({
    getFAQ: build.query<FaqItem[], void>({
      query: () => ({
        url: "/faq",
      }),
      providesTags: ["FAQ"],
    }),
  }),
});

export const { useGetFAQQuery } = FaqApi;
